<template>
  <div>
    <div class="pageTitleWrap">
      <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb>
    </div>

    <div class="main-wrap">
      <vs-card>
        <div class="form">
          <vs-row vs-type="flex" class="imageUpload">
            <vs-col
              vs-offset="1"
              vs-type="flex"
              vs-justify="left"
              vs-align="center"
              vs-w="10"
            >
              <span class="label"><span class="redText">*</span>图片链接</span>
              <ImageUpload
                v-on:updateUrl="updateUrl"
                :limitNum="1"
                :limitSize="2048"
                :imgResolutionH="750"
                :imgResolutionW="325"
                :imageUrl="imgArr"
              />
              <div class="imageTips" style="margin-left: 10px">
                建议尺寸750*325像素，文件大⼩不超过 2M，仅支持jpeg、png格式
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex">
            <vs-col
              vs-offset="1"
              vs-type="flex"
              vs-justify="left"
              vs-align="center"
              vs-w="10"
            >
              <span class="label"><span class="redText">*</span>选择活动</span>
              <!-- <v-select
                class="select-item"
                :options="activityOptions"
                :reduce="(opt) => opt.value"
                v-model="activityUrl" 
              /> -->
              
              <el-select
                @change="onChange"
                v-model="activityUrl"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in activityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex">
            <vs-col
              vs-offset="1"
              vs-type="flex"
              vs-justify="left"
              vs-align="center"
              vs-w="10"
            >
              <span class="label"
                ><span class="redText">*</span>Banner排序</span
              >
              <!-- <vs-input v-model="sort" type="number"/> -->
              <vs-input-number @mousewheel.prevent min="0" v-model="sort" />
              <div style="margin-left: 10px; color: #b9b9c3">
                *序号越小，优先级越高
              </div>
            </vs-col>
          </vs-row>
          <!-- <vs-row vs-type="flex">
            <vs-col
                    vs-offset="1"
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="center"
                    vs-w="6"
            >
              <span class="label"><span class="redText">*</span>活动状态：</span>
              <vs-switch v-model="status" />
            </vs-col>
          </vs-row> -->
        </div>
        <div class="btns">
          <vs-button @click="cancelAffirm" type="border">取消</vs-button>
          <vs-button @click="save">保存</vs-button>
        </div>
      </vs-card>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="30%" center class="dia-box">
      <div class="info-box">
        <span style="font-size: 16px; font-weight: 500">{{ errorInfo }}!</span>
        <div style="margin-top: 20px; text-align: left">
          <p>活动名称：{{ rowData.activityName }}</p>
          <p>推送类型：{{ rowData.pushType | getType }}</p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="importData">立即导入</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >暂不</el-button
        >
      </span>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="导入模板"
      :visible.sync="showImportDialog"
      width="30%"
      class="importDiv"
    >
      <span
        slot="footer"
        class="dialog-footer"
        style="text-align: center; margin-top: 20px"
      >
        <p style="line-height: 30px">导入数据以门店编码为准，请仔细填写!</p>
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/data-dist/api/dist/activityConfig/importAlonePushConfig"
          :accept="accept"
          :show-file-list="false"
          :limit="1000"
          :data="exitParam"
          :on-success="uploadSuccess"
          :headers="tokenHeader"
          :before-upload="handleBefore"
        >
          <vs-button color="primary" type="filled" class="browse-btn"
            >浏览</vs-button
          >
          <div
            style="margin-top: 20px; color: #409eff"
            @click.stop="downloadTemplate()"
          >
            下载文件模板
          </div>
          <!-- <el-button style="margin-top:20px;" @click="downloadTemplate()">下载文件模板</el-button> -->
        </el-upload>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { downloadExcel, downloadFileTemplate } from "@/utils/downloadExcel.js";
import { $busErrorCode, uploadHeader } from "@/modules/commodity-sys/common.js";
import selectPara from "@/components/selectPara";
import { DistributionApi } from "@/modules/server-api/commodity-sys/distribution";
import ImageUpload from "@/modules/commodity-sys/components/ImageUpload";
import constants from "../../../constants.ts";
export default {
  components: {
    ImageUpload,
    selectPara,
  },
  data() {
    return {
      accept: ".xlsx",
      exitParam: {
        configId: "",
      },
      rowData: {},
      errorInfo: "",
      dialogVisible: false,
      showImportDialog: false,
      imgInfo: { H: 289, W: 670 },
      breadcrumb: [],
      activityUrl: "",
      imgArr: [],
      sort: "",
      status: "",
      activityOptions: [],
      tokenHeader: uploadHeader,
    };
  },
  computed: {
    row() {
      return this.$route.params;
    },
    entryId() {
      return parseInt(this.$route.params.id) || 0;
    },
  },
  created() {
    Object.assign(this, { ...this.row });
    console.log(this.row, "=========");
    this.imgArr = !this.entryId ? [] : [this.row.imgUrl];
    this.status = this.status === 2 ? true : false;
  },
  async mounted() {
    this.breadcrumb = [
      {
        title: "门店活动",
        url: "/distribution/storeactivities",
      },
      // {
      //   title: '活动入口',
      //   url: '/distribution/storeactivities'
      // },
      {
        title: this.entryId > 0 ? "活动入口-修改" : "活动入口-新增",
        active: true,
      },
    ];
    await this.loadActivities();

    if (this.entryId) {
      this.loadData();
    }
  },
  filters: {
    getType(val) {
      const item = constants.option1.find(({ value }) => value === val) || {};
      return item.label;
    },
  },
  methods: {
    handleBefore() {
      this.exitParam.configId = this.rowData.value;
    },
    onChange(val) {
      console.log(val, this.activityOptions);
      this.rowData = this.activityOptions.find((v) => {
        return val == v.value;
      });
      //  console.log(this.rowData)
    },
    loadData() {
      DistributionApi.queryEntranceDetail({ id: this.row.id }).then((res) => {
        this.imgArr = [res.result.imgUrl];
        Object.assign(this, { ...res.result });
        console.log("2233", this.activityOptions);
        this.activityUrl = parseInt(this.activityUrl.replace("id=", "")) || "";
      });
    },
    loadActivities() {
      return DistributionApi.activityConfigList({
        status: 1,
        page: 0,
        size: 100,
        id: 0,
        activityName: "",
        type: [1, 2, 3],
        //id: this.entryId
      }).then((res) => {
        console.log(res, "========");
        this.activityOptions = res.result.data.map((item) => {
          return {
            label: item.activityName,
            value: item.id,
            activityName: item.activityName,
            pushType: item.pushType,
          };
        });
        console.log(this.activityOptions, "111111111");
      });
      return [];
    },
    updateUrl(urls) {
      this.imgArr = urls;
    },
    handleValidate() {
      let error = false;
      if (!this.activityUrl || this.sort === "" || !this.imgArr.length) {
        error = true;
      }
      console.log(error);
      return error;
    },
    save() {
      if (this.handleValidate()) {
        return this.$notifyError("请完善活动信息");
      }
      const params = {
        activityUrl: `id=${this.activityUrl}`,
        imgUrl: this.imgArr[0],
        sort: this.sort,
        status: 2,
      };
      //编辑
      if (this.row.id > 0) {
        DistributionApi.updateEntrance({ ...this.row, ...params }).then(
          (res) => {
            console.log("111", res);
            this.success();
          }
        );
        return;
      }
      DistributionApi.saveEntrance(params).then((res) => {
        console.log("222", res);
        if (res.code == 1) {
          //  this.$notifyError(res.error)
          //   this.back();
          this.dialogVisible = true;
          this.errorInfo = res.error;
        } else {
          this.success();
        }
      });
    },
    success() {
      this.$vs.notify({
        color: "success",
        title: "Success",
        text: "保存成功",
        position: "top-right",
      });
      this.back();
    },
    // 确认取消
    cancelAffirm() {
      this.$vs.dialog({
        type: "confirm",
        title: `请确认`,
        text: `是否确认取消`,
        acceptText: "确认",
        cancelText: "取消",
        accept: () => {
          this.back();
        },
      });
    },
    back() {
      this.$router.push({
        path: "/distribution/storeactivities",
        query: { tab: 1 },
      });
    },

    //下载文件模板
    downloadTemplate() {
      let url =
        "/data-dist/api/dist/activityConfig/getAlonePushExcel?type=0&configId=" +
        this.configId;
      let name = "门店活动导入模板.xlsx";
      downloadFileTemplate(url, name);
    },
    //导入
    importData(id) {
      this.dialogVisible = false;
      this.configId = this.rowData.value;
      this.showImportDialog = true;
    },
    //导入文件
    uploadSuccess(response) {
      console.log("response", response);
      if (response.code == 0 && response.code != $busErrorCode) {
        // console.log()
        this.$notifySuccess("导入成功");
        // this.getTableData();
        this.showImportDialog = false;
      } else {
        this.$notifyError(response.error || "导入数据错误,请修改后重新上传");
        this.showImportDialog = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../form.scss";

.btns {
  display: flex;
  justify-content: center;
  button {
    margin: 30px 15px;
  }
}
.con-vs-card {
  margin-top: 20px;
}
.info-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form {
  margin-top: 20px;
}
.importDiv /deep/.el-dialog__body {
  height: 0px;
  padding: 0px 0px;
}
</style>
